export default "__VITE_ASSET__DA1aO5Oe__"